export const isWithinFiveMinutes = (dateString: string | null): boolean => {
  if (!dateString) {
    return false
  }

  const currentDate = new Date()
  const givenDate = new Date(dateString)

  if (isNaN(givenDate.getTime())) {
    return false
  }
  const diffInMilliseconds = Math.abs(givenDate.getTime() - currentDate.getTime())
  const diffInMinutes = diffInMilliseconds / (1000 * 60)

  return diffInMinutes <= 5
}
